import api from "~/services/apis/antecipeApi";

export const getFeatures = async () => {
  const response = await api.get("antecipebackoffice/features");
  return response.data;
};
